import axios from 'axios';
import { buildOAuthState } from './index';

export default class GoogleFlow {
    /**
     * Redirects to accounts.google.com and logs in a user to the site
     */
    static async startAuthFlow(redirectPath, redirectQuery, customState = {}) {
        const clientId = process.env.VUE_APP_GOOGLE_CLIENT_ID;
        const state = buildOAuthState(redirectPath, redirectQuery, customState);
        console.log('State:', state);
        const scope = 'email%20profile';
        const redirectUri = this.redirectUri();

        window.open(
            `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${clientId}&scope=${scope}&state=${state}&redirect_uri=${redirectUri}&include_granted_scopes=true`,
            '_self'
        );
    }

    static async getAccessToken(authCode, state) {
        return axios({
            method: 'GET',
            url: `${
                process.env.VUE_APP_IDENTITY_SERVER_URL
            }user/authenticate-google/?code=${authCode}&state=${state}`,
        });
    }

    static redirectUri() {
        return ''.concat(
            process.env.VUE_APP_IDENTITY_SERVER_URL,
            'user/authenticate-google/callback'
        );
    }
}
